module.exports = __webpack_public_path__ + "img/avatar_hover.769d5fe0.png";